import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import { Brand } from '../../interfaces/Brand/Brand';
import { getBrands } from '../../api/Brand';

type BrandSlugsDropdownProps = {
  label?: string;
  brandSlugs: string[];
  onChange: (slugs: string[]) => void;
  disabled?: boolean;
};

export const BrandSlugsDropdown = (props: BrandSlugsDropdownProps) => {
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState<Brand[]>([]);

  useEffect(() => {
    setLoading(true);
    getBrands()
      .then(setBrands)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Autocomplete
        multiple
        disableCloseOnSelect
        limitTags={2}
        size='small'
        disabled={props.disabled}
        fullWidth
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            variant='outlined'
            fullWidth
          />
        )}
        options={brands}
        getOptionLabel={(brand) => brand.name}
        onChange={(_, selectedBrands) =>
          props.onChange(selectedBrands.map((brand) => brand.slug))
        }
        value={brands.filter((brand) => props.brandSlugs.includes(brand.slug))}
      />
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};
